import { DOCUMENT_LIBRARY_DEFAULT_SORT_CONFIG } from "./documentLibrarySortMapper";
import { createEmptyDocumentLibrarySelectedIds } from "./documentLibraryFilters";
import { cloneLocationFilters } from "./locationFilterUtils";
import { mergeSelectedIdMap } from "./mergeSelectedIdMap";
import {
  mergePositivePageNumber,
  mergeSingleColumnSortConfig,
} from "./stickyFilterMergeUtils";
import {
  clearStickyFilters,
  loadStickyFilters,
  saveStickyFilters,
} from "./stickyFilterStorage";

export const DOCUMENT_LIBRARY_SCREEN_KEYS = {
  DOCUMENT_LIBRARY: "documentLibrary",
  RFI_LIBRARY: "rfiLibrary",
  VQA_LIBRARY: "vqaLibrary",
};

const ARCHIVE_STATUS_VALUES = new Set([
  "active_only",
  "show_archived",
  "archived_only",
]);

function mergeSelectedIds(saved) {
  return mergeSelectedIdMap(saved, createEmptyDocumentLibrarySelectedIds());
}

function mergeArchiveStatusFilter(saved) {
  return ARCHIVE_STATUS_VALUES.has(saved?.archiveStatusFilter)
    ? saved.archiveStatusFilter
    : "active_only";
}

/**
 * Hydrates document-library page state from sessionStorage.
 * Each screen only reads the fields it declares via options.
 */
export function loadDocumentLibraryFilterState(screenKey, options = {}) {
  const { includeLocation = false, includeArchive = false } = options;
  const saved = loadStickyFilters(screenKey);

  const state = {
    selectedIds: mergeSelectedIds(saved?.selectedIds),
    sortConfig: mergeSingleColumnSortConfig(
      saved?.sortConfig,
      DOCUMENT_LIBRARY_DEFAULT_SORT_CONFIG
    ),
    currentPage: mergePositivePageNumber(saved?.currentPage),
  };

  if (includeLocation) {
    const locationFilters = cloneLocationFilters(saved?.locationFilters);
    state.locationFilters = locationFilters;
    state.appliedLocationFilters = cloneLocationFilters(
      saved?.appliedLocationFilters ?? locationFilters
    );
  }

  if (includeArchive) {
    state.archiveStatusFilter = mergeArchiveStatusFilter(saved);
  }

  return state;
}

/** Persists the current document-library filter state for a screen. */
export function persistDocumentLibraryFilterState(screenKey, filterState) {
  saveStickyFilters(screenKey, filterState);
}

/** Clears persisted document-library filters for a screen. */
export function clearDocumentLibraryFilterState(screenKey) {
  clearStickyFilters(screenKey);
}
